<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size md_size">
            <a href="javascript:" class="ui_close" type="button" @click="btnClose"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('TITLE.POPUP.QUICK.CATEGORY.CONFIG') }}</i>
                </dt>
                <dd>

                    <dl class="chg_quickCategory">
                        <dt>
                            <label class="checkbox-wrap">
                                <input type="checkbox" class="quick" name="quick" v-model="chkAutoCategory">
                                <i class="check-icon"></i>
                                <em>{{ $t('FIELD.POPUP.QUICK.CATEGORY.AUTO') }}</em>
                            </label>
                        </dt>
                        <dd>
                            <fieldset class="ui_fieldset set_3">
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory1_1"
                                            v-model="category1.val1"
                                            @change="changeCategory1($event, category1)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category1.list1.length > 0"
                                                v-for="item in category1.list1"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory1_2"
                                            v-model="category1.val2"
                                            @change="changeCategory2($event, category1)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category1.list2.length > 0"
                                                v-for="item in category1.list2"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory1_3"
                                            v-model="category1.val3"
                                            @change="changeCategory3($event, category1)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category1.list3.length > 0"
                                                v-for="item in category1.list3"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                            </fieldset>
                            <fieldset class="ui_fieldset set_3">
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory2_1"
                                            v-model="category2.val1"
                                            @change="changeCategory1($event, category2)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category2.list1.length > 0"
                                                v-for="item in category2.list1"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory2_2"
                                            v-model="category2.val2"
                                            @change="changeCategory2($event, category2)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category2.list2.length > 0"
                                                v-for="item in category2.list2"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory2_3"
                                            v-model="category2.val3"
                                            @change="changeCategory3($event, category2)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category2.list3.length > 0"
                                                v-for="item in category2.list3"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                            </fieldset>
                            <fieldset class="ui_fieldset set_3">
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory3_1"
                                            v-model="category3.val1"
                                            @change="changeCategory1($event, category3)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category3.list1.length > 0"
                                                v-for="item in category3.list1"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory3_2"
                                            v-model="category3.val2"
                                            @change="changeCategory2($event, category3)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category3.list2.length > 0"
                                                v-for="item in category3.list2"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p"
                                            id="quickCategory3_3"
                                            v-model="category3.val3"
                                            @change="changeCategory3($event, category3)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                        <option v-show="category3.list3.length > 0"
                                                v-for="item in category3.list3"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                            </fieldset>
                        </dd>
                    </dl>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine set_2"><!-- 200508수정(class추가) -->
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="btnClose">{{ $t('BUTTON.GLOBAL.CANCEL') }}</a>
                            <a href="javascript:" class="btn_blue" @click="btnApply">{{ $t('BUTTON.GLOBAL.APPLY') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

const fetchSetup = loginSystem => SDLUtil.postForm(
    '/basis/common/getQuickCategorySetup.skp', { systemId: loginSystem }
);

export default {
    name: 'CategoryConfigPopup',
    props: {
        rtnFunc: { type: Function }
    },
    data() {
        return {
            isCategoryLoading: true,
            isChanged: false,

            chkAutoCategory: false,
            category1: {
                list1: [],
                val1: '',
                list2: [],
                val2: '',
                list3: [],
                val3: ''
            },
            category2: {
                list1: [],
                val1: '',
                list2: [],
                val2: '',
                list3: [],
                val3: ''
            },
            category3: {
                list1: [],
                val1: '',
                list2: [],
                val2: '',
                list3: [],
                val3: ''
            },
        }
    },
    computed: {
        ...mapGetters({
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            loginSystem: 'getLoginSystem',
            loginNo: 'getLoginNo',
        }),
    },
    methods: {
        async initLoad() {
            await fetchSetup(this.loginSystem).then( data => {
                let catList = data.categoryList.rowData;
                let catSetup = data.categorySetup.rowData;

                // 카테고리 자동 등록 체크 박스 설정
                this.chkAutoCategory = StringUtil.strToBool(catSetup[0].WORK_KEY);
                if(catList.length > 0) {
                    for(let i = 0; i < catList.length; i++) {
                        let row = catList[i];
                        if(i === 0) {
                            this.setCategory(row, this.category1);

                        } else if(i === 1) {
                            this.setCategory(row, this.category2);

                        } else if(i === 2) {
                            this.setCategory(row, this.category3);

                        } else {
                            break;
                        }
                    };
                // 카테고리가 없는 경우
                } else {
                    this.setCategory({}, this.category1);
                    this.setCategory({}, this.category2);
                    this.setCategory({}, this.category3);
                };

                if(catList.length === 1) {
                    this.setCategory({}, this.category2);
                    this.setCategory({}, this.category3);

                } else if(catList.length === 2) {
                    this.setCategory({}, this.category3);
                }

                this.isCategoryLoading = false;
            })
            .catch( err => {
                SDLUtil.showLoadingBar(false);
                SDLUtil.errorAlert(err);
            });
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        async setCategory(row, categoryObj) {
            await this.setCategory1(categoryObj, row).then(() => {
                this.setCategory2(categoryObj, row);
            });
        },
        // 첫번째 카테고리 설정
        async setCategory1(categoryObj, row) {
            await this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                categoryObj.val1 = SDLUtil.nvl(row.WORK_KEY_1), categoryObj.list1 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 두번째 카테고리 설정
        async setCategory2(categoryObj, row) {
            if(!SDLUtil.isNull(categoryObj.val1)) {
                await this.getCodeComboList(categoryObj.val1, "ADM_CATEGORY_B").then(data => {
                    categoryObj.val2 = SDLUtil.nvl(row.WORK_KEY_2), categoryObj.list2 = data;

                    if(!SDLUtil.isNull(categoryObj.val2)) {
                        this.getCodeComboList(categoryObj.val2, "ADM_CATEGORY_C").then(data => {
                            categoryObj.val3 = SDLUtil.nvl(row.WORK_KEY_3), categoryObj.list3 = data;
                        });
                    }
                });

            } else {
                categoryObj.val2 = "", categoryObj.list2 = [];
                categoryObj.val3 = "", categoryObj.list3 = [];
            };
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1(e, categoryObj) {
            if(!this.isCategoryLoading) { this.isChanged = true; };
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                categoryObj.list2 = [], categoryObj.val2 = '';
                categoryObj.list3 = [], categoryObj.val3 = '';

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_B").then(data => {
                    categoryObj.list2 = data, categoryObj.val2 = '';
                });

                categoryObj.list3 = [], categoryObj.val3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2(e, categoryObj) {
            if(!this.isCategoryLoading) { this.isChanged = true; };
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                categoryObj.list3 = [], categoryObj.val3 = '';

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_C").then(data => {
                    categoryObj.list3 = data, categoryObj.val3 = '';
                });
            }
        },
        // 세번째 카테고리 변경 이벤트
        changeCategory3(e, categoryObj) {
            if(!this.isCategoryLoading) { this.isChanged = true; };
        },
        btnClose() {
            if(this.isChanged) {
                SDLUtil.confirm({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.POPUP.CHANGE.CLOSE',
                    okLabel: 'BUTTON.GLOBAL.OK',
                    onOkEvt: () => { this.$emit('close') },
                })

            } else {
                this.$emit('close');
            }
        },
        btnApply() {
            SDLUtil.showLoadingBar(true);
            let params = {
                systemId: this.loginSystem,
                chkAutoCategory: StringUtil.boolToStr(this.chkAutoCategory),
                cat1_1: this.category1.val1 || '',
                cat1_2: this.category1.val2 || '',
                cat1_3: this.category1.val3 || '',
                cat2_1: this.category2.val1 || '',
                cat2_2: this.category2.val2 || '',
                cat2_3: this.category2.val3 || '',
                cat3_1: this.category3.val1 || '',
                cat3_2: this.category3.val2 || '',
                cat3_3: this.category3.val3 || '',
            };

            return SDLUtil.postForm('/basis/common/setQuickCategory.skp', params).then(data => {
                    this.toastPopup(SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'));
                    SDLUtil.showLoadingBar(false);

                    this.rtnFunc();
                    this.$emit('close');
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });
        },
        toastPopup(msg) {
            Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
        },
    },
    created() {
        Vue.$log.info('▶ CategoryConfigPopup.vue created.');
    },
    mounted() {
        SDLUtil.showLoadingBar(true);
        this.initLoad().then(() => {
            if(!this.isCategoryLoading) {
                SDLUtil.showLoadingBar(false);
            }
        });
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/CategoryConfigPopup.vue